import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Speaker } from '@typings/participant';

type InitialState = {
  byId: Record<string, Speaker>;
};

export const initialState: InitialState = {
  byId: {},
};

export const speakersSlice = createSlice({
  name: 'speakers',
  initialState,
  reducers: {
    setSpeakerDataById: (state, action: PayloadAction<Speaker>) => {
      const oldSpeakerData = state.byId[action.payload.id] || {};
      state.byId[action.payload.id] = { ...oldSpeakerData, ...action.payload };
    },
    setSpeakersData: (state, action: PayloadAction<Speaker[]>) => {
      action.payload.forEach((speaker) => {
        const previousData = state.byId[speaker.id] || {};
        state.byId[speaker.id] = { ...previousData, ...speaker };
      });
    },
  },
});

export const { setSpeakerDataById, setSpeakersData } = speakersSlice.actions;

export default speakersSlice.reducer;
